// extracted by mini-css-extract-plugin
export default {"searchBarBtn":"SearchBar_searchBarBtn__-iiKn","placeholder":"SearchBar_placeholder__VDJbE","svg":"SearchBar_svg__buIam","cta":"SearchBar_cta__jwP4w","goBtn":"SearchBar_goBtn__kWaC4"};